package com.clany.backoffice.data.repository

import com.clany.backoffice.data.network.KeycloakConfig
import com.clany.backoffice.data.network.NetworkClient
import com.clany.backoffice.domain.repository.DashboardRepository
import com.clany.backoffice.model.DashboardMetrics

import dev.zacsweers.metro.Inject
import dev.zacsweers.metro.ContributesBinding
import com.clany.backoffice.di.AppScope
import dev.zacsweers.metro.SingleIn

@SingleIn(AppScope::class)
@ContributesBinding(AppScope::class)
@Inject
class DashboardRepositoryImpl(
    private val networkClient: NetworkClient
) : DashboardRepository {

    private val baseUrl = KeycloakConfig.API_URL

    override suspend fun getMetrics(): Result<DashboardMetrics> {
        return networkClient.request<DashboardMetrics>("$baseUrl/api/dashboard")
    }
}
